/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { HeartbeatRequest, PresenceResponse } from "../models/index";
import {
  HeartbeatRequestFromJSON,
  HeartbeatRequestToJSON,
  PresenceResponseFromJSON,
  PresenceResponseToJSON,
} from "../models/index";

export interface GetViewersRequest {
  entityType: string;
  entityId: string;
}

export interface HeartbeatOperationRequest {
  entityType: string;
  entityId: string;
  heartbeatRequest: HeartbeatRequest;
}

/**
 *
 */
export class PresenceApi extends runtime.BaseAPI {
  /**
   */
  async getViewersRaw(
    requestParameters: GetViewersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PresenceResponse>> {
    if (requestParameters["entityType"] == null) {
      throw new runtime.RequiredError(
        "entityType",
        'Required parameter "entityType" was null or undefined when calling getViewers().',
      );
    }

    if (requestParameters["entityId"] == null) {
      throw new runtime.RequiredError(
        "entityId",
        'Required parameter "entityId" was null or undefined when calling getViewers().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/presence/{entityType}/{entityId}`
          .replace(
            `{${"entityType"}}`,
            encodeURIComponent(String(requestParameters["entityType"])),
          )
          .replace(
            `{${"entityId"}}`,
            encodeURIComponent(String(requestParameters["entityId"])),
          ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PresenceResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getViewers(
    requestParameters: GetViewersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PresenceResponse> {
    const response = await this.getViewersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async heartbeatRaw(
    requestParameters: HeartbeatOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["entityType"] == null) {
      throw new runtime.RequiredError(
        "entityType",
        'Required parameter "entityType" was null or undefined when calling heartbeat().',
      );
    }

    if (requestParameters["entityId"] == null) {
      throw new runtime.RequiredError(
        "entityId",
        'Required parameter "entityId" was null or undefined when calling heartbeat().',
      );
    }

    if (requestParameters["heartbeatRequest"] == null) {
      throw new runtime.RequiredError(
        "heartbeatRequest",
        'Required parameter "heartbeatRequest" was null or undefined when calling heartbeat().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/presence/{entityType}/{entityId}/heartbeat`
          .replace(
            `{${"entityType"}}`,
            encodeURIComponent(String(requestParameters["entityType"])),
          )
          .replace(
            `{${"entityId"}}`,
            encodeURIComponent(String(requestParameters["entityId"])),
          ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HeartbeatRequestToJSON(requestParameters["heartbeatRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async heartbeat(
    requestParameters: HeartbeatOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.heartbeatRaw(requestParameters, initOverrides);
  }
}
